<div class="page-head">
    <h5 class="header-title text-primary pl-2 pl-md-1 letter-spacing">
        PRESCRIPTION TEMPLATE SEARCH / EDIT
    </h5>
</div>


<div class="row">
    <div class="col-lg-12">
        <form class="form-group" [formGroup]="tmpl_search_form">
            <div class="card m-b-30">
                <div class="card-body">
                    <div>
                        <div class="row">
                            <div class="text-primary form-group col-md-2"></div>
                            <div class="text-primary form-group col-md-2 pt-3" style="text-align: right;">Enter Template
                                Name
                            </div>
                            <div class="form-group col-md-4">
                                <input class="form-control" formControlName="tmpl_name" type="text">
                            </div>
                            <div class="text-primary form-group col-md-2 pt-2 "><button
                                    class="btn btn-primary pl-5 pr-5 mr-2 mb-2 mb-md-2 btn-rounded" type="submit"
                                    (click)="searchtmpl()">
                                    SEARCH
                                </button></div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="container-fluid" *ngIf="cate?.length">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card m-b-30">
                        <div class="card-body table-responsive">
                            <div class="col-md-12 detail-tbl">

                                <div *ngFor="let q of unique; let j = index">
                                    <span *ngIf="q.privacy==true" class="badge badge-primary"> Public</span>
                                    <span *ngIf="q.privacy==false" class="badge badge-warning"> Private</span>

                                    <h5 class="text-primary">{{ q.tmpl_name}}




                                        <i class="fa fa-plus-circle solid   fa-1x text-success ml-2 "
                                            (click)="showeditpresc(q.tmpl_name);" id="showeditpresc"></i>
                                    </h5>


                                    <div class="row col-12">
                                        <div class="col md-2 font-size-16 text-info align-middle"> Medicine Name</div>
                                        <div class="col md-2 font-size-16 text-info align-middle"> Medicine Strength
                                        </div>
                                        <div class="col md-2 font-size-16 text-info align-middle"> Intake type</div>
                                        <div class="col md-2 font-size-16 text-info align-middle"> Intake Freq</div>
                                        <div class="col md-2 font-size-16 text-info align-middle"> Intake</div>
                                        <div class="col md-2 font-size-16 text-info align-middle"> Delete</div>
                                    </div>

                                    <div class="table" *ngFor="let p of cate; let j = index" class="row col-12">

                                        <div class="col md-3 font-size-15 text-dark align-middle"
                                            *ngIf="q.tmpl_id==p.tmpl_id"> {{p?.mname}}</div>
                                        <div class="col md-2 font-size-15 text-dark align-middle"
                                            *ngIf="q.tmpl_id==p.tmpl_id"> {{p?.strength}}</div>
                                        <div class="col md-2 font-size-15 text-dark align-middle"
                                            *ngIf="q.tmpl_id==p.tmpl_id"> {{p?.intakefreq_type}}</div>
                                        <div class="col md-2 font-size-15 text-dark align-middle"
                                            *ngIf="q.tmpl_id==p.tmpl_id"> {{p?.intakefreq}}</div>
                                        <div class="col md-2 font-size-15 text-dark align-middle"
                                            *ngIf="q.tmpl_id==p.tmpl_id"> {{p?.intake}}</div>
                                        <div class="col md-2 font-size-15 text-danger align-middle"
                                            *ngIf="q.tmpl_id==p.tmpl_id">
                                            <i class="fa fa-trash fa-1x" (click)="delPresc(p?.id)"></i>
                                        </div>

                                    </div>

                                    <br /><br />
                                </div>



                                <!-- <table class="table">

                                    <tr *ngFor="let q of unique; let j = index">
                                        <h4 class="text-primary">{{ q.tmpl_name}}
                                            <i class="fa fa-plus-circle solid   fa-1x text-success "
                                                (click)="showeditpresc(q.tmpl_name);" id="showeditpresc"></i>
                                        </h4>
                                        <td>
                                            <div style="width:100%">

                                        <td style="width: 20%;" class="font-size-15 align-middle">
                                            Medicine Name</td>
                                        <td style="width: 20%;" class="font-size-15 align-middle">
                                            Intake type</td>
                                        <td style="width: 20%;" class="font-size-15 align-middle">
                                            Intake Freq</td>
                                        <td style="width: 20%;" class="font-size-15 align-middle">
                                            Intake</td>
                                        <td style="width: 20%;" class="font-size-15 align-middle">
                                            Delete</td>

                            </div>
                            <div *ngFor="let p of cate;   let i = index">
                              
                                <tr *ngIf="q.tmpl_id==p.tmpl_id">

                                    <td style="width: 25%;" class="font-size-15 text-color align-middle"> {{
                                        p?.mname}}
                                    </td>
                                    <td style="width: 20%;" class="font-size-15 text-color align-middle">
                                        {{p?.intakefreq_type}}</td>
                                    <td style="width: 20%;" class="font-size-15 text-color align-middle">{{
                                        p?.intakefreq}}
                                    </td>
                                    <td style="width: 20%;" class="font-size-15 text-color align-middle">{{
                                        p?.intake}}</td>
                                    <td style="width: 15%;" class="font-size-15 text-danger align-middle"><i
                                            class="fa fa-trash fa-1x" (click)="delPresc(p?.id)"></i>
                                    </td>




                                </tr>

                            </div>


                            </td>
                            </tr>


                            </table> -->
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid" *ngIf="cate?.length==0">NO RECORD FOUND</div>

    </div>
</div>

<ng-template #showeditprescModal let-modal>

    <div class="container-fluid  col-lg-12">
        <div style="text-align:right;"> <br /><a data-dismiss="modal" href="javascript:void(0);" class="fa fa-close"
                (click)="modal.dismiss()" style="font-size:18px;color:red;"></a>
        </div>
        <h5>&nbsp;&nbsp;Add New Medicine in <span class="text-primary" *ngIf="tmpl">
                {{tmpl[0].tmpl_name}}</span> Template&nbsp;&nbsp;</h5>

        <form class="form-group" [formGroup]="prescriptionForm">
            <div class="row">
                <div class="col-lg-12">
                    <!-- <div *ngIf="tmpl">

                        {{tmpl[0].tmpl_name}}
                    </div> -->




                    <div class="card m-b-30">
                        <div class="card-body">
                            <div formArrayName="pre_template_details">
                                <div class="row" *ngFor="
                                let x of prescriptionForm.get('pre_template_details')[
                                  'controls'
                                ];
                                let i = index;
                                trackBy: track
                              " [formGroupName]="i">
                                    <div class="col-lg-12">
                                        <div class=" form-group  row pt-2">
                                            <div class="col-md-3">
                                                <div class="text-dark"> Medicine Name </div>

                                                <input type="text" formControlName="mname" list="browsers" id="browser"
                                                    (keyup)="medicinesFet($event)" placeholder="MEDICINE NAME"
                                                    class="form-control ">
                                                <div class="row">
                                                    <datalist id="browsers">
                                                        <option *ngFor="let x of medicineAuo" [value]="x.med_name">
                                                            {{ x.med_name}}
                                                        </option>
                                                    </datalist>

                                                </div>


                                                <div *ngIf="
                                        prescription.at(i).get('mname') &&
                                        prescription.at(i).get('mname').hasError('required')
                                      " class="invalid-feedback">
                                                    This is required
                                                </div>
                                            </div>
                                            <div class=" form-group  col-md-2">
                                                <div class="text-dark">Strength </div>
                                                <input type="text" class="form-control"
                                                    placeholder="Strength (mg/tbsp/ml)" formControlName="strength" />
                                                <div *ngIf="
                                        prescription.at(i).get('strength') &&
                                        prescription
                                          .at(i)
                                          .get('strength')
                                          .hasError('required')
                                      " class="invalid-feedback">
                                                    This is required
                                                </div>
                                            </div>
                                            <div class="form-group col-md-2">
                                                <div class="text-dark"> Intake Type</div>
                                                <select formControlName="intakefreq_type" name="intakefreq_type"
                                                    class="form-control" (change)="freqTypeSelected($event, i)">
                                                    <option *ngFor="let x of intakeFreqTypesList" [value]="x.value">
                                                        {{ x.value }}
                                                    </option>
                                                </select>
                                                <div *ngIf="
                                        prescription.at(i).get('intakefreq_type') &&
                                        prescription
                                          .at(i)
                                          .get('intakefreq_type')
                                          .hasError('required')
                                      " class="invalid-feedback">
                                                    This is required
                                                </div>
                                            </div>
                                            <div class="form-group col-md-2">
                                                <div class="text-dark"> Intake Freq</div>
                                                <select formControlName="intakefreq" name="intakefreq"
                                                    class="form-control">
                                                    <option value="null" disabled selected>
                                                        Select Frequency
                                                    </option>
                                                    <option *ngFor="let x of intakefreqList[i]" [value]="x">
                                                        {{ x }}
                                                    </option>
                                                </select>
                                                <div *ngIf="
                                        prescription.at(i).get('intakefreq') &&
                                        prescription
                                          .at(i)
                                          .get('intakefreq')
                                          .hasError('required')
                                      " class="invalid-feedback">
                                                    This is required
                                                </div>
                                            </div>
                                            <div class="form-group col-md-2">
                                                <div class="text-dark"> Intake</div>
                                                <select formControlName="intake" name="intake" class="form-control">
                                                    <option>Select</option>
                                                    <option *ngFor="let x of intakeList" [value]="x">
                                                        {{ x }}
                                                    </option>
                                                </select>
                                                <div *ngIf="
                                        prescription.at(i).get('intake') &&
                                        prescription.at(i).get('intake').hasError('required')
                                      " class="invalid-feedback">
                                                    This is required
                                                </div>
                                            </div>

                                        </div>
                                        <div class="row pt-3">


                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-4"></div>
                                <div class="col-md-4">
                                    <button *ngIf="tmpl" class="btn btn-primary pl-5 pr-5 mr-2 mb-2 mb-md-2 btn-rounded"
                                        type="button" (click)="sendPrescription(tmpl[0].tmpl_id)">
                                        Save
                                    </button>
                                </div>
                                <div class="col-md-4"></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </form>


    </div>
</ng-template>